import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import quotationService from '../../src/services/quotation.service';

export const fetchQuotationList = createAsyncThunk(
  'quotation/fetchQuotationList',
  async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
    try {
      const response = await quotationService.getQuotationList(
        page,
        pagesize,
        search,
        groupId,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchArchivedQuotationList = createAsyncThunk(
  'quotation/fetchArchivedQuotationList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await quotationService.getQuotationArchiveList(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchViewQuotationById = createAsyncThunk(
  'quotation/fetchViewQuotationById',
  async ({ id }, thunkAPI) => {
    try {
      const response = await quotationService.getQuotationById(id);
      return response.data; // Return the profile data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchQuotationById = createAsyncThunk(
  'quotation/fetchQuotationById',
  async (dieProfileId, { rejectWithValue }) => {
    try {
      const response = await quotationService.getQuotationById(dieProfileId);
      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const createQuotation = createAsyncThunk(
  'quotation/createQuotation',
  async ({ values }, thunkAPI) => {
    try {
      const response = await quotationService.addQuotation(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const quotationCreateWorkoder = createAsyncThunk(
  'workorder/convert-workorder/',
  async ({ values }, thunkAPI) => {
    try {
      const response =
        await quotationService.QuotationByCreateWorkOrder(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const updateQuotation = createAsyncThunk(
  'quotation/updateQuotation',
  async ({ id, values }, thunkAPI) => {
    try {
      const response = await quotationService.updateQuotation(id, values);
      return response.data; // Return the updated die group data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteQuotation = createAsyncThunk(
  'quotation/deleteQuotation',
  async (id, thunkAPI) => {
    try {
      await quotationService.deleteQuotation(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const unArchiveQuotation = createAsyncThunk(
  'quotation/unArchiveQuotation',
  async (id, thunkAPI) => {
    try {
      await quotationService.unArchiveQuotationRecord(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

const initialState = {
  data: [], // List
  list: [],
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  status: 'idle',
  error: null,
  loading: false,
  hasMore: true,
};

const quotationSlice = createSlice({
  name: 'quotation',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetQuotationData: state => {
      state.data = []; // This will clear the list
    },
    resetQuotationList: state => {
      state.list = []; // This will clear the list
    },
    resetCurrentQuotationPage: state => {
      state.currentPage = 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchQuotationList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchQuotationList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchQuotationList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchArchivedQuotationList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchArchivedQuotationList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchArchivedQuotationList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchQuotationById.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotationById.fulfilled, (state, action) => {
        state.loading = false;
        state.activeProfileRecord = action.payload;
      })
      .addCase(fetchQuotationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(createQuotation.pending, state => {
        state.status = 'loading';
      })
      .addCase(createQuotation.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createQuotation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
    builder
      .addCase(updateQuotation.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateQuotation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const updateDieProfile = action.payload;
        const index = state.data.findIndex(
          group => group.id === updateDieProfile.id,
        ); // Find the index of the updated group
        if (index !== -1) {
          state.data[index] = updateDieProfile; // Replace the old group with the updated one
        }
      })
      .addCase(updateQuotation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(deleteQuotation.pending, state => {
        state.status = 'loading';
      })
      .addCase(deleteQuotation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
      })
      .addCase(deleteQuotation.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(unArchiveQuotation.pending, state => {
        state.status = 'loading';
      })
      .addCase(unArchiveQuotation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
      })
      .addCase(unArchiveQuotation.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  resetQuotationData,
  resetQuotationList,
  resetCurrentQuotationPage,
} = quotationSlice.actions;
export default quotationSlice.reducer;
